
import Parse from "@/main.js"
import Vue from "vue";
import Router from "vue-router";

import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";

import ArticleWrapper from "./views/articles/Wrapper.vue";
import SectionDashboard from "./views/SectionDashboard.vue";
import ContentPreview from "./views/ContentPreview.vue";
import FormBuilderWrapper from "./views/FormBuilderWrapper.vue";

import MetaFormsList from "./views/metaForms/MetaFormsList.vue";
import FormPreview from "./views/FormPreview";
import FormSubmitter from "./views/FormSubmitter";

import SurveyWrapper from "./views/surveys/Wrapper";
import SurveysDashboard from "./views/surveys/SurveysDashboard.vue";
import SurveyList from "./views/surveys/SurveyList.vue";
import SurveySubmissions from "./views/surveys/SurveySubmissions.vue";
import Submission from "./views/surveys/Submission";

import FileWrapper from "./views/files/Wrapper.vue";
import ContentCreator from "./views/ContentCreator.vue";

import SectionMetaForms from "./views/SectionMetaForms.vue";
import SectionObjectsWrapper from "./views/SectionObjectsWrapper.vue";

import UsersWrapper from "./views/UsersWrapper.vue";
import User from "./views/User.vue";

import Filters from "./views/Filters.vue";
import Department from "./views/Department.vue";
import Departments from "./views/Departments.vue";

import MapWrapper from "./views/maps/Wrapper.vue";

import Words from "./views/Words.vue";
import Word from "./views/Word.vue";
import { store } from "./store/index";

Vue.use(Router);

const AuthGuard = (to, from, next) => {
  if (to.meta.isPublicView) {
    next();
  } else {
    if (store.getters.user) {
      // if (
      //   store.getters.user.get("roles").includes("manager") &&
      //   to.matched[0].name == "departments"
      // ) {
      //   next("/");
      // }

      if (
        !store.getters.user.get("roles").includes("admin") &&
        !store.getters.user.get("roles").includes("manager") &&
        !store.getters.user.get("roles").includes("guest") &&
        ((to.matched[0].name == "surveys" &&
          !store.getters.user.get("roles").includes("surveys")) ||
          (to.matched[0].name == "articles" &&
            !store.getters.user.get("roles").includes("articles")) ||
          (to.matched[0].name == "files" &&
            !store.getters.user.get("roles").includes("files")) ||
          (to.matched[0].name == "maps" &&
            !store.getters.user.get("roles").includes("maps")) ||
          (to.matched[0].name == "usersWrapper" &&
            !store.getters.user.get("roles").includes("admin")) ||
          (to.matched[0].name == "departments" &&
            store.getters.user.get("roles").includes("guest")) ||
          (to.matched[0].name == "words" &&
            !store.getters.user.get("roles").includes("admin")))
      ) {
        next("/");
      }
    }

    next();
    if (to.name == "login" && Parse.User.current()) {
      next("/");
    } else if (Parse.User.current() || to.name == "login") {
      next();
    } else {
      next({ name: "login" });
    }
  }
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/public/:id",
      name: "publicView",
      component: ContentPreview,
      meta: {
        hideSidebar: true,
        isPublicView: true
      }
    },

    {
      path: "/words",
      name: "words",
      component: Words,
      beforeEnter: AuthGuard,
      meta: {
        hideSidebar: true
      }
    },
    {
      path: "/words/:id",
      name: "word",
      component: Word,
      beforeEnter: AuthGuard,
      meta: {
        hideSidebar: true
      }
    },
    {
      path: "/departments",
      name: "departments",
      component: Departments,
      beforeEnter: AuthGuard,
      meta: {
        hideSidebar: true
      }
    },
    {
      path: "/departments/:id",
      name: "department",
      component: Department,
      beforeEnter: AuthGuard,
      meta: {
        hideSidebar: true
      }
    },
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
      beforeEnter: AuthGuard,
      meta: {
        hideSidebar: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: AuthGuard
    },
    {
      path: "/filters",
      name: "login",
      component: Login,
      beforeEnter: AuthGuard
    },

    // survyes
    {
      path: "/surveys",
      name: "surveys",
      component: SurveyWrapper,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "reports/list",
          name: "surveyFilters",
          component: Filters,
          beforeEnter: AuthGuard
        },
        {
          path: ":scope/:category/form/:id",
          name: "formBuilderWrapper",
          component: FormBuilderWrapper,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category/:form_slug/data_submitter/:id",
          name: "formSubmitter",
          component: FormSubmitter,
          meta: {
            hideSidebar: false,
            isPublicView: false
          }
        },

        {
          path: ":scope/:category/:form_slug/list/:id",
          name: "submission",
          component: Submission,
          meta: {
            hideSidebar: false,
            isPublicView: false
          }
        },

        {
          path: "/surveys/public/:scope/:category/:form_slug/list/:id",
          name: "publicSubmission",
          component: Submission,
          meta: {
            hideSidebar: true,
            isPublicView: true
          }
        },

        // for users
        {
          path: ":scope/:category/:form_slug/list",
          name: "surveySubmissions",
          component: SurveySubmissions,
          meta: {
            hideSidebar: false,
            isPublicView: false
          }
        },

        // for public submissions
        {
          path: "/surveys/public/:scope/:category/:form_slug/:surveyId/list",
          name: "submissionsPublicView",
          component: SurveySubmissions,
          meta: {
            hideSidebar: true,
            isPublicView: true
          }
        },

        // for public form
        {
          path: "/surveys/public/:scope/:category/:form_slug/:surveyId/new",
          name: "publicFormSubmitter",
          component: FormSubmitter,
          meta: {
            hideSidebar: true,
            isPublicView: true
          }
        },

        {
          path: ":scope/:category",
          name: "surveysList",
          component: SurveyList
        },
        {
          path: ":id",
          name: "formPreview",
          component: FormPreview,
          meta: { hideSidebar: true }
        },

        {
          path: "/",
          name: "survyesDashboard",
          component: SurveysDashboard
        }
      ]
    },

    // articles
    {
      path: "/articles",
      name: "articles",
      component: ArticleWrapper,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "reports/list",
          name: "articleFilters",
          component: Filters,
          beforeEnter: AuthGuard
        },

        {
          path: ":scope/:category/meta-forms/:id",
          name: "formBuilderWrapper",
          component: FormBuilderWrapper,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category",
          name: "articlesList",
          component: SectionObjectsWrapper
        },
        {
          path: "meta-forms/preview/:id",
          name: "formPreview",
          component: FormPreview,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category/edit/:id",
          name: "articleForm",
          component: ContentCreator,
          meta: { hideSidebar: true }
        },

        {
          path: ":scope/:category/meta-forms",
          name: "articleMetaForms",
          component: SectionMetaForms
        },

        {
          path: ":scope/:category/:id",
          name: "articlePreview",
          component: ContentPreview,
          meta: { hideSidebar: true, isPublicView: false }
        },

        {
          path: "/",
          name: "sectionDashboard",
          component: SectionDashboard
        }
      ]
    },

    // files
    {
      path: "/files",
      name: "files",
      component: FileWrapper,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "reports/list",
          name: "fileFilters",
          component: Filters,
          beforeEnter: AuthGuard
        },
        {
          path: ":scope/:category/:meta-forms/:id",
          name: "formBuilderWrapper",
          component: FormBuilderWrapper,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category",
          name: "filesList",
          component: SectionObjectsWrapper
        },
        {
          path: ":meta-forms/preview/:id",
          name: "formPreview",
          component: FormPreview,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category/edit/:id",
          name: "fileUpload",
          component: ContentCreator,
          meta: { hideSidebar: true }
        },

        {
          path: ":scope/:category/meta-forms",
          name: "fileMetaForms",
          component: SectionMetaForms
        },

        {
          path: ":scope/:category/:id",
          name: "filePreview",
          component: ContentPreview,
          meta: { hideSidebar: true, isPublicView: false }
        },

        {
          path: "/",
          name: "sectionDashboard",
          component: SectionDashboard
        }
      ]
    },

    // maps
    {
      path: "/maps",
      name: "maps",
      component: MapWrapper,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "reports/list",
          name: "mapFilters",
          component: Filters,
          beforeEnter: AuthGuard
        },

        {
          path: ":scope/:category/:meta-forms/:id",
          name: "formBuilderWrapper",
          component: FormBuilderWrapper,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category",
          name: "mapsList",
          component: SectionObjectsWrapper
        },
        {
          path: ":meta-forms/preview/:id",
          name: "formPreview",
          component: FormPreview,
          meta: { hideSidebar: true }
        },

        {
          path: ":scope/:category/edit/:id",
          name: "mapUpload",
          component: ContentCreator,
          meta: { hideSidebar: true }
        },
        {
          path: ":scope/:category/meta-forms",
          name: "mapMetaForms",
          component: SectionMetaForms
        },

        {
          path: ":scope/:category/:id",
          name: "mapPreview",
          component: ContentPreview,
          meta: { hideSidebar: true, isPublicView: false }
        },

        {
          path: "/",
          name: "sectionDashboard",
          component: SectionDashboard
        }
      ]
    },

    // meta form
    {
      path: "/metaForms",
      name: "metaForms",
      component: MetaFormsList,
      beforeEnter: AuthGuard,
      meta: { hideSidebar: true }
    },

    {
      path: "/users",
      name: "usersWrapper",
      component: UsersWrapper,
      beforeEnter: AuthGuard,
      meta: { hideSidebar: true }
    },

    {
      path: "/users/:id",
      name: "users",
      component: User,
      beforeEnter: AuthGuard,
      meta: { hideSidebar: true }
    }
  ]
});

export default router;
